
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuditInterface } from '@/services/Dev-scrum/interfaces';
import DevScrumRepository from '@/services/Dev-scrum';

@Component({
  inject: [
    'devScrumRepository',
  ],
})
export default class DeleteAuditDialog extends Vue {
  private readonly devScrumRepository!: DevScrumRepository;

  @Prop() private readonly audit!: AuditInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete this audit?`;
  }

  private async deleteAudit(): Promise<void> {
    try {
      await this.devScrumRepository.deleteAuditById(this.audit.id);
      this.$successDialog.show(`Audit has been deleted.`);
      this.$emit('audit-deleted', this.audit.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
